import { SortIcon } from '../../../assets/icons/SortIcon';
import { ITableHeader } from '../Table.types';
import classes from './TableHeader.module.css';

export const TableHeader = (props: ITableHeader) => {
    const { label, align = 'left', width, minWidth } = props;

    const style: React.CSSProperties = {
        textAlign: align,
        ...(width && { width }),
        ...(minWidth && { minWidth }),
    };

    return (
        <th className={classes['table-header-cell']} style={style}>
            <div style={{ display: 'flex' , alignItems: 'center'}}>
                {label}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                }}>
                    <SortIcon />
                </div>
            </div>
        </th>
    );
};
